import axios from 'axios';

export default class AppGateway {
  async getEstimatedWaitTime(orgDomain, orgId, appId) {
    return axios.get(`${orgDomain}/api/reporting/v1/orgs/${orgId}/estimated-wait`, {
      params: { endpointAddress: appId, endpointType: 'CHAT' },
    });
  }
}
